export const SET_ALL_AWARD_PROCEDURES = "Setzt alle Verfahren neu";
export const SET_CURRENT_AWARD_PROCEDURE = "Setzt das Verfahren als Current";
export const SET_AWARD_PROCEDURE_STATUS =
  "Setzt den Status der Veröffentlichung eines Verfahren";
export const SET_CURRENT_TAB_IN_LIST = "Setzt das aktuell gewählte Tab";
export const SET_LOCK = "Setze das Lock";
export const SET_REQUEST_STATE = "Setze einen bestimmten Request State";
